<template>
  <div class="door-to-door-book-page">
  
    
    <v-container fluid>
       <v-layout align-center justify-center>
          <v-flex >

        <v-row justify="center" class="">
          <v-col cols="12" class="">
            <h1 class="title text-capitalize">


            <span v-if="!trip.direction_id">{{trip.long_name}}</span>
            <span v-if="trip.direction_id">{{trip.long_name_inv}}</span>  
            </h1>
            <p>{{new Date(trip.date).toLocaleDateString(`${$i18n.locale}`, {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'}) }}</p>
          </v-col>
        </v-row>

        <v-col cols="12">
          <v-row justify="center">
            <v-col cols="3" md="2">
              <svg height='300px' width='300px' fill="#000000" version="1.1" x="0px" y="0px"
                viewBox="-69.5 -52.5 97.5 109"
                style="width:100%;height:auto;enable-background:new -69.5 -52.5 97.5 109;" xml:space="preserve">
                <g>
                  <path
                    d="M20.9-11h-3.6c-0.8,0-1.4,0.6-1.4,1.4V0.9c0,0.8,0.6,1.4,1.4,1.4h3.6c0.8,0,1.4-0.6,1.4-1.4V-9.6   C22.3-10.4,21.7-11,20.9-11z">
                  </path>
                  <path
                    d="M-60.3-10.9h-3.6c-0.8,0-1.4,0.6-1.4,1.4V1c0,0.8,0.6,1.4,1.4,1.4h3.6c0.8,0,1.4-0.6,1.4-1.4V-9.5   C-58.9-10.3-59.5-10.9-60.3-10.9z">
                  </path>
                  <path
                    d="M-56.5,32.1c-0.1-0.2-0.1-0.3-0.1-0.3v9.6c0,0.8,0.6,1.4,1.4,1.4h6.7c0.8,0,1.4-0.6,1.4-1.4v-5.1h-4.5   C-54.1,36.3-56.2,34.4-56.5,32.1z">
                  </path>
                  <path
                    d="M8.4,36.3H3.8v5.1c0,0.8,0.6,1.4,1.4,1.4h6.7c0.8,0,1.4-0.6,1.4-1.4v-9.6c0,0,0,0.1-0.1,0.3C12.9,34.4,10.8,36.3,8.4,36.3z   ">
                  </path>
                  <path
                    d="M6.8-44.3c0,0-14.9-0.9-28.5-0.9s-27,0.8-27,0.8c-2.7,0-5,3.1-5,5.8c0,0-3.8,28.5-3.8,31.2c0,2.7,1,38,1,38   c0,2.7,2.2,4.9,4.9,4.9h7.8l3.9-1.8h36l4.4,1.8h8c2.7,0,4.9-2.2,4.9-4.9c0,0,1.3-31.1,1.3-37.3c0-6.2-2.9-32.1-2.9-32.1   C11.7-41.4,10.6-43.9,6.8-44.3z M-52.6,12.5c-1.5-0.5-1.8-1.7-1.9-2.4c-0.5-1.7-0.3-5.5-0.3-5.5c0-0.9,0.7-2.5,3.3-1.5   c0,0,2.9,1.1,4.6,2.1c0.8,0.5,1.6,1.6,2.4,3.7c0.8,2.1,1.7,4.7,1.5,5.3c-0.1,0.4-0.9,0.3-2.4,0C-46.4,14-50.5,13.2-52.6,12.5z    M-45.4,31c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5c1.4,0,2.5,1.1,2.5,2.5S-44.1,31-45.4,31z M-7.2,26c-0.4,1.2-1.4,2.4-2.5,2.5   c-4.9,0.4-18.5,0.5-23.6,0.1c-1.1-0.1-2.4-0.6-3-2.6c-1.8-5.7-4.9-19.6-4.9-19.6h39.3C-1.9,6.4-5.5,20.6-7.2,26z M1.9,31   c-1.4,0-2.5-1.1-2.5-2.5S0.6,26,1.9,26s2.5,1.1,2.5,2.5S3.3,31,1.9,31z M11,10.7c-0.2,0.6-0.4,1.9-1.9,2.4   c-2.1,0.7-6.1,1.5-7.1,1.7c-1.6,0.3-2.3,0.4-2.4,0c-0.1-0.6,0.7-3.2,1.5-5.3c0.8-2.1,1.6-3.2,2.4-3.7C5.2,4.7,8,3.6,8,3.6   c2.6-1,3.3,0.7,3.3,1.5C11.3,5.2,11.5,9,11,10.7z M11.5-10.1c-0.1,0.8-0.4,2.2-0.7,3.1c-0.2,0.5-0.3,0.8-0.9,0.8   c-0.3,0-16.8-0.4-32-0.3c-15.2,0-30.4-0.1-30.7-0.1c-0.5,0-0.7-0.2-0.9-0.8c-0.3-0.8-0.6-2.2-0.7-3.1c-0.1-1.3,1.7-13.8,1.7-13.8   c0.3-2,1-2.8,2.5-2.8c0,0,8.6-0.6,28-0.6c19.4,0,29.6,0.9,29.6,0.9c1.5,0,2.2,0.7,2.5,2.8C10.1-24,11.6-11.4,11.5-10.1z">
                  </path>
                </g>
              </svg>
            </v-col>
          </v-row>
        </v-col>
         <v-form v-model="valid" ref="form">
        <div v-if="!trip.direction_id">
  <v-combobox v-model="from_model" :loading="isFromLoading" :rules="startPlaceRules" required :items="from_items" :search-input.sync="search_from"
            item-text="name" item-value="id" cache-items hide-no-data hide-details :label="$t('startplace')"
            :placeholder="$t('startplace_text')" prepend-icon="place" clearable return-object>
          </v-combobox>
          <v-combobox :disabled=true v-model="to_model" :loading="isToLoading"  :items="to_items" :search-input.sync="search_to"
            item-text="name" item-value="id" cache-items hide-no-data hide-details :label="$t('endplace')"
            :placeholder="$t('endplace_text')" prepend-icon="place" clearable return-object >
          </v-combobox>
         
       </div>
       <div v-if="trip.direction_id">
         
           <v-combobox :disabled=true v-model="from_model" :loading="isFromLoading"  :items="from_items" :search-input.sync="search_from"
            item-text="name" item-value="id" cache-items hide-no-data hide-details :label="$t('startplace')"
            :placeholder="$t('startplace_text')" prepend-icon="place" clearable return-object >
          </v-combobox>
          <v-combobox   v-model="to_model" :loading="isToLoading" :items="to_items" :rules="endPlaceRules" required :search-input.sync="search_to"
            item-text="name" item-value="id" cache-items hide-no-data hide-details :label="$t('endplace')"
            :placeholder="$t('endplace_text')" prepend-icon="place" clearable return-object>
          </v-combobox>
</div>

        <v-row justify="center" class="">
          <v-col cols="6" class="">
            <v-text-field prepend-icon="person" :label="$t('first_name')" :placeholder="$t('first_name_text')"
              :hint="$t('first_name_text')" v-model="first_name" :rules="firstNameRules" required>
            </v-text-field>
        </v-col>
        <v-col cols="6" class="">
            <v-text-field :label="$t('last_name')" :placeholder="$t('last_name_text')" :hint="$t('last_name_text')"
              v-model="last_name" :rules="lastNameRules" required>
            </v-text-field>
          </v-col>
        </v-row>

        <v-row justify="center" class="py-0">
            <v-col cols="6" class="py-0">
              <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field :disabled=true v-model="date_a" :label="$t('startdate')" :placeholder="$t('startdate_text')" prepend-icon="event" readonly v-on="on"></v-text-field>
                </template>
                <v-date-picker :locale=bcp47($i18n.locale)  v-model="date_a" @input="menu1 = false" no-title></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6" class="py-0">
              <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" :nudge-right="40" :return-value.sync="time_a" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field :disabled=true v-model="time_a" :label="$t('starttime')" :placeholder="$t('starttime_text')" prepend-icon="access_time" readonly v-on="on"></v-text-field>
                </template>
                <v-time-picker :locale=bcp47($i18n.locale) v-if="menu2" v-model="time_a" @click:minute="$refs.menu2.save(time_a)">
                </v-time-picker>
              </v-menu>
            </v-col>
          </v-row>

        <v-text-field :label="$t('people')" :placeholder="$t('people_text')" v-model="people" prepend-icon="person"
            hide-details single-line type="number" min=1>
            <template v-slot:append>
              <v-btn tile color="primary" class="ma-0" @click="inc(8)">+</v-btn>
              <v-btn tile color="primary" class="ma-0" @click="dec">-</v-btn>
            </template>
        </v-text-field>

         

        <v-row justify="center" class="">
          <v-col cols="12" class="">
            <v-text-field prepend-icon="phone" :label="$t('cellphone')" :placeholder="$t('cellphone_text')"
              :hint="$t('cellphone_hint')" v-model="phone" :rules="phoneRules" required>
            </v-text-field>
          </v-col>
        </v-row>




        <v-row>
          <v-col cols="12">
            <v-textarea rows="3" prepend-icon="comment" :label="$t('pickup_info')" :hint="$t('pickup_info')"
              v-model="notes"></v-textarea>
          </v-col>
        </v-row>

 <v-alert class="pa-6" type="success">
            <p>{{ $t('transfer_for') }} {{ people }} {{ $tc('person',people) }}:</p>
            <p class="text-center display-1">80 €</p>
          </v-alert>


        <v-row>
          <v-col cols="12" class="mb-9">
        <v-card class="d-flex justify-space-between" flat tile>
          <v-btn :disabled="!valid" :loading=isBookSaving color="primary" @click="Book()">{{ $t('confirm') }}</v-btn>
          <v-btn depressed @click="$router.go(-1)">
            <v-icon left>mdi-menu-up</v-icon> {{ $t('back') }}
          </v-btn>

        </v-card>
                  </v-col>
        </v-row>

        </v-form>
        </v-flex>
      </v-layout>

    </v-container>
  </div>
</template>

<style scoped>
input[type=number]::-webkit-inner-spin-button, 
input[type=number]::-webkit-outer-spin-button { 
  -webkit-appearance: none; 
  margin: 0; 
}
input[type=number] {
    -moz-appearance:textfield;
}
</style>

<script>
/* eslint-disable no-console */
Number.prototype.pad = function(size) {
    var s = String(this);
    while (s.length < (size || 2)) {s = "0" + s;}
    return s;
}

  export default {
    name: 'DoorToDoor',
    data() {
      return {
        valid: false,
 
        startPlaceRules: [
          (v) => !!v || this.$t('first_name_required'),
          (v) => v && v.length >= 4 || this.$t('first_name_required')
        ],
        endPlaceRules: [
          (v) => !!v || this.$t('endplace_required'),
          (v) => v && v.length >= 4 || this.$t('endplace_required')
        ],
        firstNameRules: [
          (v) => !!v || this.$t('first_name_required'),
          (v) => v && v.length >= 2 || this.$t('first_name_required')
        ],
        lastNameRules: [
          (v) => !!v || this.$t('last_name_required'),
          (v) => v && v.length >= 2 || this.$t('last_name_required')
        ],
        phoneRules: [
          (v) => !!v || this.$t('phone_required'),
          (v) => v && v.length >= 5 || this.$t('phone_required')
        ],
        menu1: false,
        menu2: false,
        search_from: null,
        search_to: null,
        isFromLoading: false,
        isToLoading: false,
        isBookSaving: false
      }
    },
     computed: {
      date_a: {
        get() {
          
         return this.$store.state.doorToDoorTrip.date
        },
        set(val) {
        this.$store.commit('transfer_set_date_a',val)
        }
      },
      time_a: {
        get() {
          //console.log(this.$store.state.doorToDoorStop)
          //return this.$store.state.transfer.time_a
          
          //return "10:00";
       
          if (!this.$store.state.doorToDoorTrip.direction_id) {
            return this.datehour(this.$store.state.doorToDoorStop.arrival_time,"01:00:00")
          } else {
            return this.datehour(this.$store.state.doorToDoorStop.departure_time,"00:00:00")
          }
          
        },       
        set(val) {
          
         // this.$store.state.transfer.time=val
            this.$store.commit('transfer_set_time_a',val)
        }
      },
      trip: {
         get() {
          return this.$store.state.doorToDoorTrip
        }
      },
      stop: {
        get() {
          return this.$store.state.doorToDoorStop
        }
      },
      /*
      * User Details
      */
      from_model: {
        get() {
          if (!this.$store.state.doorToDoorTrip.direction_id) {
            return this.$store.state.transfer.from;
          } else {
            this.$store.commit('transfer_set_from',this.$store.state.doorToDoorStop.name)
            return this.$store.state.doorToDoorStop.name;
          }
          
        },
        set(val) {
            this.$store.commit('transfer_set_from',val)
        }
      },
      from_items: {
        get() {
          return this.$store.state.transfer.from_items
        },
        set(val) {
          this.$store.dispatch('transferSearchFrom',val)
        }
      },
      to_model: {
        get() {
          if (this.$store.state.doorToDoorTrip.direction_id) {
            return this.$store.state.transfer.to;
          } else {
            this.$store.commit('transfer_set_to',this.$store.state.doorToDoorStop.name)
            return this.$store.state.doorToDoorStop.name;
          }
          
        },
        set(val) {
            this.$store.commit('transfer_set_to',val)
        }
      },
      to_items: {
        get() {
          return this.$store.state.transfer.to_items
        },
        set(val) {
          this.$store.dispatch('transferSearchTo',val)
        }
      },
      people: {
        get() {
          return this.$store.state.transfer.people
        },
        set(val) {
          this.$store.dispatch('transferSetPeople',val)
        }
      },
      first_name: {
        get() {
          return this.$store.state.transfer.first_name;
        },
        set(val) {
          this.$store.dispatch('transferSetFirstName',val)
        }
      },
      last_name: {
        get() {
          return this.$store.state.transfer.last_name;
        },
        set(val) {
          this.$store.dispatch('transferSetLastName',val)
        }
      },
      phone: {
        get() {
          return this.$store.state.transfer.phone;
        },
        set(val) {
          this.$store.dispatch('transferSetPhone',val)
        }
      },
      notes: {
        get() {
          return this.$store.state.transfer.notes;
        },
        set(val) {
          this.$store.dispatch('transferSetNotes',val)
        }
      },
    },
    watch: {
      async search_from(val) {
            this.isFromLoading = true
            try {
              await this.$store.dispatch('transferSearchFrom',val)
              this.isFromLoading = false
            } catch (error) {
              this.isFromLoading = false
            }
      },
      async search_to(val) {
            this.isToLoading = true
            try {
              await this.$store.dispatch('transferSearchTo',val)
              this.isToLoading = false
            } catch (error) {
              this.isToLoading = false
            }
      },
    },
    methods: {
       dec() {
        this.$store.commit('transfer_people_remove')
      },
      inc(max) {
         this.$store.commit('transfer_people_add',max)
      },
      bcp47(locale) {
        return locale + "-" + locale.toUpperCase()
      },
      datehour(date,timestring) {
        var dummyDate = "1/1/2000";
        var timeDiff = (new Date(dummyDate + " " + date)).getTime() - (new Date(dummyDate + " " + timestring)).getTime();
        var seconds = ~~(timeDiff/1000);
        var hour = ~~(seconds/60/60);
        var min = ~~((seconds - 60*60*hour) / 60);
        return hour.pad()+":"+min.pad();
      },
      Book() {
     //   console.log(this.$store)
             this.$store.dispatch('transferBook',this.$store.transfer).then(() => {
              this.$router.push('/thankyou');
            });

        //this.$store.commit('transfer_book')
        

      },
    },
  }

</script>